import { Link } from 'react-router-dom';  
import Counter from './Counter';  
import Boxes from './Boxes';  
import Artcircle from './Artcircle';  
import Infra from './Infra';   
import useWow from './useWow.module';


export default function VSKHome(props) {  
    useWow();
    return (  
        <>   
            <div className="main-banner">  
                <div className="d-table">  
                    <div className="d-table-cell">  
                        <div className="container">  
                            <div className="row h-100 justify-content-center align-items-center">  
                                <div className="col-lg-5">  
                                    <div className="hero-content">  
                                        <h1>Weaving Heritage into Every Thread</h1>  
                                        <p>Explore the beauty and craftsmanship of traditional textiles, where heritage meets innovation.</p>  
                                        <Link to="/VSKAbout">  
                                            <a href="/" className="btn btn-primary">Know more</a>  
                                        </Link>  
                                    </div>  
                                </div>  

                                <div className="col-lg-6 offset-lg-1">  
                                    <div className="banner-image">  
                                        <img src="/img/home-fab.png" className="wow fadeInRight" data-wow-delay="0.6s" alt="home-pic" />  
                                        <img src="/img/home-fab.png" className="wow fadeInUp" data-wow-delay="0.6s" alt="main-pic" />  
                                    </div>  
                                </div>  
                            </div>  
                        </div>  
                    </div>  
                </div>  

            </div>  

            <Boxes />  
            <Artcircle />  
            <Infra />  
            <Counter />  
        </>  
    );  
}